import getCatalog from './get-catalog';
import getWishlist from './get-wishlist';

export default {
	getCatalog,
	getWishlist
};
